<template>
	<side-window :tabs="tabs" :active="active" class="contact" :title="value.type in $store.getters.tasks ? $store.getters.tasks[value.type].label : 'Opgave'" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view label="Afdeling" v-model="entity.department_id" :options="departments" optionValueName="id" />
					<employee-select-view v-model="entity" label="Ansvarlig" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Gruppe" v-model="entity.task_group_id" :options="taskGroups" optionValueName="id" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<contact-select-view v-model="entity" label="Kunde" :optional="true" @select="contactSelect" />
					<string-view v-model="entity.reference" label="Kundereference" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<string-view v-model="entity.name" label="Navn" />
					<string-view v-model="entity.phone" label="Telefon" :optional="true" />
					<string-view v-model="entity.email" label="E-mail" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Dato type" v-model="entity.details.date_type" :options="[
						{
							label: 'Kendt dato',
							value: 'default'
						},
						{
							label: 'Ukendt dato',
							value: 'unknown'
						},
						{
							label: 'Vi bestemmer ankomst',
							value: 'any'
						}
					]" />
					<date-select-view v-show="!entity.details.date_type || entity.details.date_type == 'default' || entity.details.date_type == 'any'" label="Dato" v-model="entity.due_start" :controller="$store.state.popupController" :suggestions="suggestions" />
					<form-line-layout v-show="!entity.details.date_type || entity.details.date_type == 'default'">
						<clock-select-view label="Ankomst mellem" v-model="entity.from" :controller="$store.state.popupController" />
						<clock-select-view v-model="entity.to" :controller="$store.state.popupController" />
					</form-line-layout>
					<div class="side-window__heading">
						Send SMS påmindelse dagen før
						<switch-view v-model="entity.reminder" />
					</div>
				</div>
				<div v-show="active == 'details'">
					<clock-select-view label="Varighed" v-model="entity.details.duration" :controller="$store.state.popupController" />
				</div>
				<div v-show="active == 'details'">
					<string-view v-model="entity.customer_desc" label="Beskrivelse til kunden" :optional="true" />
					
					<div class="label edit" style="padding-top: 22px;">
						<div class="edit__label">Timepris</div>
						<auto-complete-view style="height: 30px;" url="/products/search/" v-model="entity.hour_rate" :map="productMap" :labelMap="productLabel" :descMap="productDesc" :validator="productValidator" :clearMap="clearProduct" @select="selectProduct" :lazy="true" />
					</div>
				</div>
				<div v-show="active == 'details'">
					<text-view label="Bemærkninger" :height="130" :optional="true" v-model="entity.remarks" />
				</div>
				<div v-show="active == 'extent'">
					<select-view label="Type" v-model="entity.details.type" optionValueName="label" :options="[
						{
							label: '1++'
						},
						{
							label: '1+'
						},
						{
							label: '1'
						},
						{
							label: '2'
						},
						{
							label: '3'
						},
						{
							label: '4'
						}
					]" />
					<string-view v-model="entity.details.cubic" label="Kubik" />
					<string-view v-model="entity.details.area" label="Areal" optional />
				</div>
				<div v-show="active == 'files'">
					<file-list-view v-model="entity.details.files" />
				</div>
				<div v-show="active == 'requirements'">
					<requirements-view v-model="entity.requirements" />
				</div>
				<div v-show="active == 'packaging'">
					<packaging-view v-model="entity.details.packaging" />
				</div>
				<route-view v-show="active == 'route'" v-model="entity.details.route" :contact_id="entity.contact_id" />
				<div v-show="active == 'photos'">
					<photos-view v-model="entity.details.photos" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import MoveTaskModel from '../model/MoveTask'
	import merge from '../functions/merge'

	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import ContactSelectView from '../views/ContactSelectView';
	import PackagingView from '../views/PackagingView';

	export default {
		data: function () {
			return {
				entity: {},
				packaging: [],
				ORDER: [],
				active: 'details',
				instructions: [],
				departments: [],
				suggestions: [],
				types: [],
				taskGroups: [],
				prices: []
			};
		},
		watch: {
			from(newVal) {
				this.to = newVal;
			},
			'entity.contact_id': function (n) {
				if (n) {
					var self = this;

					this.axios
						.get('/contacts/' + n + '/tasks/latest/')
						.then(function (r) {
							self.suggestions = r.data._items.map(function (item) {
								return {
									date: 	(new Date(item.due_start_from)).format('Y-m-d'),
									label: 	self._types.hasOwnProperty(item.type) ? self._types[item.type].label : ''
								};
							});
							//self.departments = r.data._items;

							
						});
				} else {
					this.suggestions = [];
				}
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'EmployeeSelectView': EmployeeSelectView,
			'ContactSelectView': ContactSelectView,
			'PackagingView': PackagingView
		},
		computed: {
			_types() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];
				}

				return r;
			},
			_roles() {
				var r = {};
				var role;
				var props;
				var prop;

				for (var i = 0; i < this.roles.length; ++i) {
					role = this.roles[i];
					props = {};
					
					for (var j = 0; j < role.props.length; ++j) {
						prop = role.props[j];
						props[prop.name] = prop.default;
					}

					r[role.name] = {
						enabled: false,
						props: props
					};
				}

				return r;
			},
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'extent',
						label: 'Omfang'
					},
					{
						name: 'files',
						label: 'Filer'
					},
					{
						name: 'requirements',
						label: 'Behov'
					},
					{
						name: 'packaging',
						label: 'Emballage'
					},
					{
						name: 'route',
						label: 'Rute'
					},
					{
						name: 'photos',
						label: 'Fotos'
					}
				];
			}
		},
		props: {
			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function () {}
			},
			value: {
				type: Object,
				default() {
					return merge({}, MoveTaskModel);
				}
			}
		},
		methods: {
			getPrice(obj) {
				

				for (var i = 0; i < this.prices.length; ++i) {
					if (this.prices[i].product_id == obj.id) return this.prices[i].price;
				}

				return obj.price;
			},
			selectProduct(obj) {
				
				this.entity.hour_rate = obj.price;
			},
			productMap(obj) {
				

				const p = this.getPrice(obj);

				

				return {
					price: p,
					label: obj.label
				};
			},
			productLabel(obj) {
				

				return obj.price;
			},
			productDesc(obj) {
				

				return obj.label;
			},
			productValidator(obj) {
				

				return true;;
			},
			clearProduct(obj) {
				

				return {
					hour_rate: 0
				};
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				this.submit(this.entity);
			},
			contactSelect(obj) {
				

				this.entity.name = obj.name;
				this.entity.email = obj.email;
				this.entity.phone = obj.phone;

				// Also on route
				if (!this.entity.id) {
					
					this.entity.details.route[0].address 	= obj.address;
					this.entity.details.route[0].zip 		= obj.zip;
					this.entity.details.route[0].city 		= obj.city;
					this.entity.details.route[0].country 	= obj.country;
				}

				this.prices = obj._embedded.prices;
				
			}
		},
		mounted: async function() {
			
			

			var self = this;

			this.entity = merge({}, this.value);

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.types = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/tasks/groups/')
				.then(function (r) {
					self.taskGroups = r.data._items;
					//self.departments = r.data._items;
				});

			if (this.entity.contact_id) {
				const c = (await this.axios.get('/contacts/' + this.entity.contact_id)).data;
				this.prices = c._embedded.prices;
			}


			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
